import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field } from 'formik';
import { FieldTypes, booleanUrlField, pluginCode } from 'drapcode-constant';
import { drapcodeIcon, iconForField } from '../custom/icon-library';
import CustomSelect from './CustomSelect';
import CustomInputWithIcon from '../ui/CustomInputWithIcon';
import TooltipInfo from '../docs/TooltipInfo';
import { getFieldOptionsForMultiTenantPlugin } from '../utils/plugin_utils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../features/plugin/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import { ColorCodeField } from '../../features/collections/item/ItemField/ColorCodeField';

const fixKey = 'environment_variable';
const fixTenantKey = 'current_tenant';

const { boolean, large_text, number } = FieldTypes;

class CreateFormForPlugin extends Component {
  state = {
    encryptedFields: {},
    originalValues: {},
    encryptedValues: {},
  };

  componentDidMount() {
    const { pluginData, actions, match } = this.props;
    this.setState(pluginData);
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleEncryptValue = async (fieldName, currentValue) => {
    const { setFieldValue, actions, match } = this.props;
    const version = match.params.version;
    const projectId = match.params.projectId;

    const { encryptedFields, originalValues, encryptedValues } = this.state;

    if (encryptedFields[fieldName]) {
      setFieldValue(fieldName, originalValues[fieldName]);
      this.setState((prevState) => ({
        encryptedFields: {
          ...prevState.encryptedFields,
          [fieldName]: false,
        },
      }));
      return;
    }

    if (encryptedValues[fieldName]) {
      setFieldValue(fieldName, encryptedValues[fieldName]);
      this.setState((prevState) => ({
        encryptedFields: {
          ...prevState.encryptedFields,
          [fieldName]: true,
        },
      }));
      return;
    }

    try {
      let apiResponse = await actions.loadEncryptInstalledPluginDetail({
        projectId,
        version,
        setFieldValue,
        fieldName,
        value: currentValue,
      });

      this.setState((prevState) => ({
        encryptedFields: {
          ...prevState.encryptedFields,
          [fieldName]: true,
        },
        originalValues: {
          ...prevState.originalValues,
          [fieldName]: currentValue,
        },
        encryptedValues: {
          ...prevState.encryptedValues,
          [fieldName]: apiResponse.data.setting,
        },
      }));

      setFieldValue(fieldName, apiResponse.data.setting);
    } catch (error) {
      console.error('Error encrypting value:', error);
    }
  };

  createForm = () => {
    const {
      field,
      name,
      code,
      events,
      setFieldValue,
      setFieldTouched,
      pages,
      roles,
      collections,
      update,
      pluginData,
    } = this.props;
    const { type, isMulti, label, disabled, placeholder, description, isEncrypted } = field;
    const showEncryptButton = isEncrypted && type !== 'password' && update === true;
    const { encryptedFields } = this.state;
    const isFieldEncrypted = encryptedFields[name];

    if (type === 'select') {
      const options = this.loadSelectOptions(field, code, events, name, pages, roles, collections);
      return (
        <CustomSelect
          name={name}
          isMulti={isMulti ? isMulti : false}
          value={this.state[name]}
          options={options}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          onChangeValue={this.handleChange}
          placeholder={label}
          isDisabled={
            (name === 'multiTenantCollection' ||
              (name === 'userSettingsCollection' && pluginData.userSettingsCollection) ||
              (name === 'subTenantCollection' && pluginData.subTenantCollection)) &&
            update
          }
        />
      );
    } else if (type === 'textarea') {
      return (
        <Field
          type={type}
          as="textarea"
          name={name}
          className="form-control form-control-sm"
          placeholder={label}
          autoComplete="off"
        />
      );
    } else if (type === boolean.id) {
      return (
        <div className="form-check" style={{ flex: '1 1 auto' }}>
          <label
            className="form-check-label"
            style={disabled ? { color: '#aaaaaa' } : { color: 'rgba(0, 0, 0, 0.87)' }}
          >
            <Field
              type="checkbox"
              name={name}
              disabled={disabled}
              className="form-check-input"
              title={label}
            />
            <span className="form-check-sign">
              <span className="check"></span>
            </span>
            {label} <br />
            {description && <small>({description})</small>}
          </label>
        </div>
      );
    } else if (type === 'color') {
      const fieldObj = { fieldName: name, fieldTitle: { en: label }, placeholder: { en: label } };
      return <ColorCodeField field={fieldObj} setFieldValue={setFieldValue} showErrorMsg={false} />;
    } else {
      return (
        <>
          <Field
            type={type}
            name={name}
            className="form-control form-control-sm"
            placeholder={placeholder ? placeholder : label}
            autoComplete="off"
          />
          {showEncryptButton && (
            <button
              type="button"
              aria-label={isFieldEncrypted ? 'Field is encrypted' : 'Encrypt this field'}
              onClick={() => this.handleEncryptValue(name, this.props.values[name])}
              className="btn btn-sm btn-primary mt-1 ml-2"
              title={isFieldEncrypted ? 'Field is already Decrypted' : 'Decrypt this field'}
            >
              {isFieldEncrypted ? (
                <i className={`wb webconnect-eye-slash-fill`}></i>
              ) : (
                <i className={`wb webconnect-eye-fill`}></i>
              )}
            </button>
          )}
        </>
      );
    }
  };

  loadSelectOptions = (field, code, events, name, pages, roles, collections) => {
    const { installedPlugins } = this.props;
    let options = [{ value: '', label: `Select ${field.label}` }];
    if (code === pluginCode.MAGIC_LINK_LOGIN) {
      events.map((e) => options.push({ value: `${e.uuid}`, label: `${e.eventTitle}` }));
    } else if (code === pluginCode.MULTI_TENANT_SAAS) {
      switch (name) {
        case 'pages':
          pages.map((page) => options.push({ value: `${page.uuid}`, label: `${page.name}` }));
          break;
        case 'creatorRoles':
        case 'tenantRoles':
          roles.map((role) => options.push({ value: `${role.uuid}`, label: `${role.name}` }));
          break;
        case 'multiTenantCollection':
        case 'userSettingsCollection':
        case 'subTenantCollection':
          collections
            .filter(
              (collection) =>
                collection.collectionName !== 'user' && collection.collectionName !== 'role',
            )
            .map((collection) =>
              options.push({
                value: `${collection.uuid}`,
                label: `${collection.collectionTitle}`,
              }),
            );
          break;
        case 'tenantReferenceField':
          const selectedCollectionId = this.props.values['multiTenantCollection'];
          options = getFieldOptionsForMultiTenantPlugin(selectedCollectionId, collections);
          break;
        case 'userSettingsField':
          const collectionId = this.props.values['userSettingsCollection'];
          options = getFieldOptionsForMultiTenantPlugin(collectionId, collections);
          break;
        case 'subTenantField':
          const subTenantCollectionId = this.props.values['subTenantCollection'];
          options = getFieldOptionsForMultiTenantPlugin(subTenantCollectionId, collections);
          break;
        default:
          field.options.map((option) =>
            options.push({ value: `${option.value}`, label: `${option.label}` }),
          );
          break;
      }
    } else if (
      [
        pluginCode.OAUTH_2,
        pluginCode.TWITTER_LOGIN,
        pluginCode.FACEBOOK_LOGIN,
        pluginCode.EMAIL_OTP_AUTHENTICATOR,
        pluginCode.SMS_OTP_AUTHENTICATOR,
        pluginCode.EMAIL_OTP_CONSENT_VALIDATOR,
        pluginCode.SMS_OTP_CONSENT_VALIDATOR,
        pluginCode.TWO_FACTOR_AUTHENTICATION,
      ].includes(code)
    ) {
      if (['excludedRole', 'defaultRole'].includes(name) && Array.isArray(roles)) {
        options = roles.map((role) => ({
          value: name === 'excludedRole' ? `${role.name}` : `${role.uuid}`,
          label: `${role.name}`,
        }));
      } else if (name === 'smsServicePlugin') {
        options = [];
        const smsPluginMap = {
          TWILIO: 'Twilio',
          AWS_SNS: 'AWS SNS',
          PARKEN: 'Parken',
          TELNYX: 'Telnyx',
        };
        if (Array.isArray(installedPlugins)) {
          options = installedPlugins
            .filter((plugin) => smsPluginMap[plugin.code])
            .map((plugin) => ({
              value: plugin.code,
              label: smsPluginMap[plugin.code],
            }));
        }
      } else if (name === 'emailServicePlugin') {
        options = [];
        const pluginMap = {
          AWS_SES: 'AWS SES',
          SENDGRID: 'SendGrid',
          RESEND: 'Resend',
        };
        if (Array.isArray(installedPlugins)) {
          options = installedPlugins
            .filter((plugin) => pluginMap[plugin.code])
            .map((plugin) => ({
              value: plugin.code,
              label: pluginMap[plugin.code],
            }));
        }
      } else if (name === 'otpConsentCollections') {
        collections.map((collection) =>
          options.push({
            value: `${collection.collectionName}`,
            label: `${collection.collectionTitle}`,
          }),
        );
      }
    } else if (code === pluginCode.SOCKET_IO) {
      collections.map((collection) =>
        options.push({
          value: `${collection.collectionName}`,
          label: `${collection.collectionTitle}`,
        }),
      );
    } else if (code === pluginCode.LOGIN) {
      pages.forEach((page) => options.push({ value: `${page.slug}`, label: `${page.name}` }));
    } else {
      field.options.map((option) =>
        options.push({ value: `${option.value}`, label: `${option.label}` }),
      );
    }
    return options;
  };

  render() {
    const {
      field,
      name,
      setFieldValue,
      setFieldTouched,
      projectDetail,
      isTenantPlugin,
      tenantCollection,
      code,
    } = this.props;
    const {
      type,
      label,
      required,
      isEnvironmentAllowed,
      isMulti,
      description,
      isCurrentTenantAllowed,
      isEncrypted,
    } = field;

    const { encryptedFields } = this.state;
    const isFieldEncrypted = encryptedFields[name];
    const showEncryptButton = isEncrypted && type !== 'password' && this.props.update === true;

    let icon;
    if (showEncryptButton && !isFieldEncrypted) {
      icon = 'lock';
    } else {
      icon = type === boolean.id ? type + '-toggle' : type;
    }

    let environmentVariable = [];
    if (projectDetail) {
      const { environments } = projectDetail;
      if (!environments[0] || !environments[0].constants) {
        environmentVariable = [{ label: 'No Env Variable Available', value: '' }];
      } else {
        environmentVariable = environments[0].constants.map((env) => ({
          label: env.name,
          value: `${fixKey}.${env.name}`,
        }));
      }
    }
    let tenantsFields = [];
    if (tenantCollection) {
      let { fields } = tenantCollection;
      fields = fields.filter((field) =>
        [...booleanUrlField, large_text.id, number.id].includes(field.type),
      );
      if (!fields || fields.length === 0) {
        tenantsFields = [{ label: 'No Field in Tenant', value: '' }];
      } else {
        tenantsFields = fields.map((env) => ({
          label: env.fieldTitle.en,
          value: `${fixTenantKey}.${env.fieldName}`,
        }));
      }
    }
    return (
      <>
        {name === 'access_key' && code === pluginCode.AWS_S3 && (
          <>
            <tr>
              <td colSpan="6">
                <h3>Private Bucket Configuration</h3>
                <h5>
                  <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;Enter Private S3 bucket
                  details for secure file uploads and storage.
                </h5>
              </td>
            </tr>
          </>
        )}
        <tr>
          <td>
            <label>{label}</label>
            {required ? <span className="required"> *</span> : ''}
            <p className="errors">
              <ErrorMessage name={name} />
            </p>
          </td>
          <td>
            <CustomInputWithIcon title={label} icon={icon}>
              {this.createForm()}
              {description ? (
                <TooltipInfo
                  title={description}
                  headerText={label}
                  showHeader={true}
                  showArrow={true}
                  append={true}
                />
              ) : (
                <div className="input-group-append">
                  <span className="input-group-text" style={{ visibility: 'hidden' }}>
                    <i className={`wb ${drapcodeIcon('description')}`}></i>
                  </span>
                </div>
              )}
            </CustomInputWithIcon>
          </td>
          <td>OR</td>
          <td>
            {isEnvironmentAllowed ? (
              <CustomInputWithIcon title={label} icon="select" required={false}>
                <CustomSelect
                  name={name}
                  isMulti={isMulti ? isMulti : false}
                  value={this.state[name]}
                  options={environmentVariable}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  onChangeValue={this.handleChange}
                  placeholder={label}
                />
              </CustomInputWithIcon>
            ) : (
              <p className="text-center">--</p>
            )}
          </td>
          <td>OR</td>
          <td>
            {isTenantPlugin && isCurrentTenantAllowed ? (
              <CustomInputWithIcon title={label} icon="select" required={false}>
                <CustomSelect
                  name={name}
                  isMulti={false}
                  value={this.state[name]}
                  options={tenantsFields}
                  onChange={setFieldValue}
                  onBlur={setFieldTouched}
                  onChangeValue={this.handleChange}
                  placeholder={label}
                />
              </CustomInputWithIcon>
            ) : (
              <p className="text-center">--</p>
            )}
          </td>
        </tr>
        {name === 'use_default' && code === pluginCode.AWS_S3 && (
          <>
            <tr>
              <td colSpan="6">
                <h3>Public Bucket Configuration</h3>
                <h5>
                  <i className={`wb ${drapcodeIcon('info')}`}></i>&nbsp;Enter Public S3 bucket
                  details (DrapCode requires public S3 bucket to store file icons). If not provided,
                  icons will be stored in DrapCode's public S3 bucket.
                </h5>
              </td>
            </tr>
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    plugin: state.plugin,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateFormForPlugin);
